export default __webpack_public_path__ + "static/media/eth.4d3dbebf.svg";